export const About = () => {
  return (
    <>
      <section className="about">
        <img
          src="https://raw.githubusercontent.com/whizkydee/olaolu.dev/12fddfb9fb9e422928120d77b3b94f26f67374f0/landing/src/assets/avatar-shapes.svg"
          alt=""
        />
        <img
          src="https://raw.githubusercontent.com/whizkydee/olaolu.dev/12fddfb9fb9e422928120d77b3b94f26f67374f0/landing/src/assets/cornerstone-patterns-left.svg"
          alt=""
        />
        <img
          src="https://raw.githubusercontent.com/whizkydee/olaolu.dev/12fddfb9fb9e422928120d77b3b94f26f67374f0/landing/src/assets/cornerstone-patterns-left.svg"
          alt=""
        />
        ...
        <div className="_aboutWrapper">
          {/* <img src="https://raw.githubusercontent.com/whizkydee/olaolu.dev/12fddfb9fb9e422928120d77b3b94f26f67374f0/landing/src/assets/avatar-shapes.svg" alt=""/>  */}

          <article className="_textAbt">
            <h1 className="h1BG">User Experience</h1>

            <p>
              I'm not a typical designer positioned behind a photoshop screen
              adjusting pixels, but I integrate UI design at the best of my
              abilities to give the user the best experiences they deserve . I'm
              committed to creating fluent user experiences while exploring its
              the design ecosystem at large.
            </p>
          </article>

          <article className="_textAbt">
            <h1 className="h1BG">Engineering</h1>

            <p>
              In building JavaScript applications,I am the guy for the job ,
              skilled in popular technologies such as{" "}
              <a href="https://reactjs.org/">React Js</a>,{" "}
              <a href="https://nodejs.org/en/">Node Js</a> and{" "}
              <a href="https://www.typescriptlang.org/">
                {" "}
                Typescript [ Javascript Senior Brother ]
              </a>{" "}
              and many more . I'm equipped with just the right tools, and can
              absolutely function independently of them to deliver fast,
              resilient solutions optimized for scale — performance to the user
            </p>
          </article>
        </div>
      </section>
    </>
  );
};
